<template>
  <section class="header-container" v-if="!rootStore.isMobile">
    <nav>
      <back-button v-if="archive"></back-button>
      <span v-if="archive"
        >Prullenmand van
        <span class="trash-title">{{ archive.name }}</span></span
      >
      <span v-else class="trash-title">Prullenmand</span>
    </nav>
    <section class="actions">
      <button v-if="archive" class="main-button" @click="emptyTrash()">
        prullenmand legen
      </button>
      <search-menu
        v-if="hasArchives"
        :folder-id="folderId"
        :allArchivesOnly="true"
        @search-completed="goToSearchResults"
      >
      </search-menu>
    </section>
  </section>

  <section class="header-mobile" v-else>
    <section class="header-top">
      <button v-if="archive" class="main-button" @click="emptyTrash()">
        prullenmand legen
      </button>
      <search-menu
        v-if="hasArchives"
        :folder-id="folderId"
        :allArchivesOnly="true"
        @search-completed="goToSearchResults"
      >
      </search-menu>
    </section>
    <section class="header-bottom">
      <nav>
        <back-button v-if="archive"></back-button>
        <span v-if="archive"
          >Prullenmand van
          <span class="trash-title">{{ archive.name }}</span></span
        >
        <span v-else class="trash-title">Prullenmand</span>
      </nav>
    </section>
  </section>
</template>

<script>
import BackButton from '@/components/ui/BackButton.vue'
import SearchMenu from '@/features/filestore/children/SearchMenu.vue'
import { EventBus } from '@/eventbus/EventBus'
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'
import ConfirmationDialog from '@/dialogs/ConfirmationDialog.vue'

export default {
  name: 'TrashHeader',
  props: ['folderId'],
  components: { SearchMenu, BackButton },
  computed: {
    ...mapStores(useFileStoreStore),
    archive() {
      return this.folderId
        ? this.fileStoreStore.getArchiveByFolderId(this.folderId)
        : undefined
    },
    hasArchives() {
      return this.fileStoreStore.hasArchives
    }
  },
  methods: {
    goToSearchResults() {
      this.$router.push({ name: 'fileStoreSearchResults' })
    },
    emptyTrash() {
      this.$modal.show(
        ConfirmationDialog,
        {
          text:
            'Weet u zeker dat u de inhoud van de prullenmand definitief wilt verwijderen?',
          buttons: [
            {
              title: 'Annuleren',
              class: 'pill-button secondary'
            },
            {
              title: 'Verwijderen',
              class: 'pill-button',
              handler: () => {
                EventBus.emit('empty-trash-clicked')
              }
            }
          ]
        },
        {
          width: 400,
          height: 'auto'
        }
      )
    }
  }
}
</script>

<style scoped lang="scss">
.header-container {
  width: 100%;
  display: grid;
  grid-template-columns: auto 180px;
}

nav {
  font-weight: 500;
  display: flex;
  align-items: center;
}

.actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 20px;

  .main-button {
    margin-right: 8px;
  }
}

.trash-title {
  color: var(--sub-color);
}

.header-mobile {
  width: 100%;
  .header-top {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 24px;
    padding-right: 8px;
  }
  .header-bottom {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 24px;
  }
}
</style>
